import { jSith } from "../jquery-replacement";

export namespace S25Number {
    export function parseFloat(str: any): number {
        str = jSith.toStr(str);
        return Number.parseFloat(str);
    }

    export function isFloat(n?: string | number): n is string | number {
        return !isNaN(parseFloat(n));
    }

    export function toFloat(n: string | number): number {
        return parseFloat(n) || 0;
    }

    export function add(num: number) {
        return function (x: number): number {
            return x + num;
        };
    }

    export function toInt(n: string | number | undefined): number {
        return parseInt(n, 10) || 0;
    }

    export function isInt(n: string | number): boolean {
        if (typeof n === "number") return n % 1 === 0;
        if (typeof n === "string") return !!n && /^-?\d+$/.test(n);
        return false;
    }

    export const isParsableAsInt = jSith.isParsableAsInt;

    export const parseInt = jSith.parseInt;

    /** Parses a plus-delimited list of integers; skips blank segments and non-finite values. */
    export function parseIntListFromPlusSeparated(value: string): number[] {
        if (!value.trim()) {
            return [];
        }
        const parsedIds: number[] = [];
        for (const segment of value.split("+")) {
            const parsedId = parseInt(segment);
            if (Number.isFinite(parsedId)) {
                parsedIds.push(parsedId);
            }
        }
        return parsedIds;
    }

    export function lastDigit(num: string | number): number {
        num = Math.abs(parseInt(num));
        const numDigits: number = Math.floor(Math.log10(num)) + 1;
        for (let i: number = numDigits - 1; i >= 1; i--) {
            const ithPower: number = Math.pow(10, i);
            num -= Math.floor(num / ithPower) * ithPower;
        }
        return num;
    }

    export function isNumeric(obj: any): boolean {
        return obj && !isNaN(parseFloat(obj)) && isFinite(obj);
    }

    export function toFixed(number: number, digits: number): string {
        const len = number.toString().length,
            power: number = len - digits;

        // number if shorter than requested - return as is
        if (power < 1) {
            return number + "";
        }
        return (number / Math.pow(10, power)).toFixed(0);
    }

    // Clamps a number between a minimum and maximum value
    // Return min if number is smaller than min, return max is number is greater than max
    export function clamp(n: number, min: number, max: number) {
        if (min > max) max = min; // Make sure that max is not smaller than min
        return n < min ? min : n > max ? max : n;
    }

    export function equals(a: number, b: number, epsilon: number = 0) {
        return Math.abs(a - b) <= epsilon;
    }

    export function getOrdinalSuffix(num: number): string {
        const lastDigit = num % 10;
        const lastTwoDigits = num % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
            return "th";
        }

        switch (lastDigit) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }
}
